/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {CurrencyBaseContract} from '../../api/contracts/currency/currency-base.contract';
import {CurrencyBaseModel} from './currency-base.model';


export class CurrencyBaseMapper {
    static fromCurrencyBaseContract(input: CurrencyBaseContract): CurrencyBaseModel {
        let model: CurrencyBaseModel;

        if (input != null) {
            model = {
                alphabeticCode: input.alphabeticCode,
                numericCode: input.numericCode,
                minorUnit: input.minorUnit,
                name: input.name
            };
        }
        return model;
    }
}
